import React from "react";
import { FaCoffee, FaFire, FaUserFriends } from "react-icons/fa";
import styles from "./ProductFeatures.module.css"; // 1. Import the CSS Module

function ProductFeatures() {
  return (
    // 2. Use the 'styles' object
    <section className={styles.featuresSection}>
      <h2>Our Commitment to Quality</h2>
      <div className={styles.featuresGrid}>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>
            <FaCoffee />
          </div>
          <h3>Finest Sourced Beans</h3>
          <p>
            We travel the world to find the highest quality, ethically sourced
            beans for a truly exceptional cup.
          </p>
        </div>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>
            <FaFire />
          </div>
          <h3>Expert Roasting</h3>
          <p>
            Our master roasters craft unique profiles for each bean, unlocking
            their full potential and flavor.
          </p>
        </div>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>
            <FaUserFriends />
          </div>
          <h3>Passionate Baristas</h3>
          <p>
            More than just skill, our team shares a deep love for coffee and a
            passion for serving our community.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ProductFeatures;
